import { Icon, IconProps } from "../";

export const Glock = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 56 56" {...props}>
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M44.3332 15.7461V23.9332H30.7334V29.3731H22.5735V34.813H19.8536V40.2529H11.6665V32.0658H14.3865V23.9332H11.6665V15.7461H44.3332ZM27.9862 23.9332H22.5735V26.6259H27.9862V23.9332Z"
          fill="currentColor"
        />
      </>
    </Icon>
  );
};
